module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "report-row"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('p', [_c('strong', [_vm._v(_vm._s(_vm.title))])])])]), _vm._v(" "), (_vm.showViewMode) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localViewMode),
      expression: "localViewMode"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": 'snapshot',
      "checked": _vm._q(_vm.localViewMode, 'snapshot')
    },
    on: {
      "change": function($event) {
        _vm.localViewMode = 'snapshot'
      }
    }
  }), _vm._v(" Por ano\n    ")]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localViewMode),
      expression: "localViewMode"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": 'evolution',
      "checked": _vm._q(_vm.localViewMode, 'evolution')
    },
    on: {
      "change": function($event) {
        _vm.localViewMode = 'evolution'
      }
    }
  }), _vm._v(" Evolução\n    ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localPeriodType),
      expression: "localPeriodType"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": 'years',
      "checked": _vm._q(_vm.localPeriodType, 'years')
    },
    on: {
      "change": function($event) {
        _vm.localPeriodType = 'years'
      }
    }
  }), _vm._v(" Anos\n    ")]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localPeriodType),
      expression: "localPeriodType"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": 'dates',
      "checked": _vm._q(_vm.localPeriodType, 'dates')
    },
    on: {
      "change": function($event) {
        _vm.localPeriodType = 'dates'
      }
    }
  }), _vm._v(" Datas\n    ")])]), _vm._v(" "), (_vm.localPeriodType === 'years' && _vm.isRange) ? [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8 col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.localStartYear),
      expression: "localStartYear",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val)
        });
        _vm.localStartYear = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.availableYears), function(year) {
    return _c('option', {
      key: 'start-' + year,
      attrs: {
        "disabled": year > _vm.localEndYear
      },
      domProps: {
        "value": year
      }
    }, [_vm._v(_vm._s(year))])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8 col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.localEndYear),
      expression: "localEndYear",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val)
        });
        _vm.localEndYear = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.availableYears), function(year) {
    return _c('option', {
      key: 'end-' + year,
      attrs: {
        "disabled": year < _vm.localStartYear
      },
      domProps: {
        "value": year
      }
    }, [_vm._v(_vm._s(year))])
  }), 0)])])] : _vm._e(), _vm._v(" "), (_vm.localPeriodType === 'years' && !_vm.isRange) ? [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.localYear),
      expression: "localYear",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val)
        });
        _vm.localYear = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.availableYears), function(year) {
    return _c('option', {
      key: year,
      domProps: {
        "value": year
      }
    }, [_vm._v(_vm._s(year))])
  }), 0)] : _vm._e(), _vm._v(" "), (_vm.localPeriodType === 'dates') ? [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Data inicial")]), _vm._v(" "), _c('DatePicker', {
    attrs: {
      "bootstrapStyling": true,
      "language": _vm.datepickerLanguage,
      "value": _vm.startDateObject,
      "typeable": true,
      "format": "dd-MM-yyyy"
    },
    on: {
      "selected": _vm.onStartDateSelected
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Data final")]), _vm._v(" "), _c('DatePicker', {
    attrs: {
      "bootstrapStyling": true,
      "language": _vm.datepickerLanguage,
      "value": _vm.endDateObject,
      "typeable": true,
      "format": "dd-MM-yyyy"
    },
    on: {
      "selected": _vm.onEndDateSelected
    }
  })], 1)] : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-4 col-md-2"
  }, [_c('p', {
    staticClass: "year-label"
  }, [_c('strong', [_vm._v("De")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-4 col-md-2"
  }, [_c('p', {
    staticClass: "year-label"
  }, [_c('strong', [_vm._v("Até")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13f5e213","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/ReportPeriodFilter.vue
// module id = 688
// module chunks = 1